import { AfterViewInit, OnInit, ViewChild } from "@angular/core";
import { Component } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs/operators";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { DocumentFilter } from "src/app/models/DocumentFilter";
import { DocumentFiltersOptions } from "src/app/models/DocumentFiltersOptions";
import { Roles } from "src/app/models/Enums";
import { DocumentFiltersService } from "src/app/services/document-filters.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-document-filters",
  templateUrl: "./document-filters.component.html",
  styleUrls: ["./document-filters.component.scss"],
  standalone: false,
})
export class DocumentFiltersComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  faSpinner = faSpinner;
  dataSource = new MatTableDataSource<DocumentFilter>([]);
  selectedFamCode: string;
  selectedUserRole: Roles;
  options: DocumentFiltersOptions;
  selectedFilePrefix: string;
  selectedFileExtension: string;
  fileExtensionsForFamCodeAndRole: string[];

  pageSize: number = 50;
  page: number = 1;

  constructor(
    private documentFiltersService: DocumentFiltersService,
    public modalService: ModalService,
    private globalOverlayService: GlobalOverlayService,
  ) {}

  ngOnInit(): void {
    this.loadDocumentFiltersOptions();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  loadDocumentFiltersOptions() {
    this.globalOverlayService.show();
    this.documentFiltersService
      .getDocumentFilterOptions()
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => (this.options = response));
  }

  onFamCodeOrUserRoleChange() {
    if (this.isRoleAndFamSelected()) {
      this.loadFileExtensionsAndPrefixes();
      this.selectedFilePrefix = null;
      this.selectedFileExtension = null;
    }
  }

  isRoleAndFamSelected() {
    return this.selectedFamCode && this.selectedUserRole;
  }

  loadFileExtensionsAndPrefixes() {
    this.globalOverlayService.show();
    this.documentFiltersService
      .getDocumentFilters(this.selectedFamCode, this.selectedUserRole)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        this.dataSource.data = response;
        // remove fileExtension from addSelect, that have been already added previously
        this.fileExtensionsForFamCodeAndRole = this.options.extensions.filter(
          (x) => !response.some((y) => x === y.filterValue),
        );
      });
  }

  onNewDocumentFilterAdd(filterValue: string) {
    if (!filterValue) {
      return;
    }

    const docFilter = new DocumentFilter();
    docFilter.famCode = this.selectedFamCode;
    docFilter.filterValue = filterValue;
    docFilter.role = this.selectedUserRole;

    this.globalOverlayService.show();
    this.documentFiltersService
      .addDocumentFilter(docFilter)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe(() => this.loadFileExtensionsAndPrefixes());
  }

  onDocumentFilterDelete(documentFilter: DocumentFilter) {
    this.globalOverlayService.show();
    this.documentFiltersService
      .deleteDocumentFilter(documentFilter)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe(() => this.loadFileExtensionsAndPrefixes());
  }
}
